import { createContext, useContext } from "react";

export type AuthTokenContextContent = {
  authenticate: (token: string) => void;
  logout: () => void;
  token: null | string;
};

export const AuthTokenContext = createContext<AuthTokenContextContent | null>(
  null,
);

export const useAuthTokenContext = () => useContext(AuthTokenContext);
